/**
 * Initialization of ckeditor to provide automatic data-binding and data-configuration.
 */
var Giant = Giant || {};

;(function($, window, document, undefined) {

    if (typeof CKEDITOR === 'undefined') {
        return;
    }

    var pluginName = 'giantCKEditor',
        dataPrefix = 'ckeditor',
        $window = $(window),
        defaults = {
            toolbar: 'Narrow'
        };

    function CKEditor(element, options) {
        this.scope = element;
        this.$scope = $(element);

        this.options = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    CKEditor.prototype = {

        init: function() {
            var self = this;

            CKEDITOR.replace(this.scope, this.options)
            return this;
        }

    };

    $.fn[pluginName] = function (options) {
        var dataPrefixLength = dataPrefix.length;

        return this.each(function () {
            if (!$.data(this, 'plugin-' + pluginName)) {

                // parse data-options
                var data = $(this).data(),
                    options = {},
                    settings = '';

                if (pluginName in data) {
                    settings = data[pluginName];
                    // pass options
                    if ($.type(settings) === 'object') {
                        options = settings;
                    }
                }

                // pass all options to plugin
                $.each(data, function(key, value) {
                    if (key.substr(0, dataPrefixLength) === dataPrefix && key !== dataPrefix) {
                        var id = key.substr(dataPrefixLength);
                        id = id.substr(0,1).toLowerCase() + id.substr(1);
                        options[id] = value;
                    }
                });

                $.data(this, 'plugin-' + pluginName, new CKEditor(this, options));
            }
        });
    };

    $.fn[pluginName].defaults = defaults;

    // listen to change event and init self
    $(document).on('dom:change', function(event) {
        $('[data-ckeditor]', event.target).filter(function() {
            return !$(this).closest('.template').length;
        }).giantCKEditor();
    });
    $('[data-ckeditor]').filter(function() {
        return !$(this).closest('.template').length;
    }).giantCKEditor();

    Giant.CKEditor = CKEditor;

})(jQuery, window, document);